import { render, staticRenderFns } from "./m-support-buttons.vue?vue&type=template&id=730e814e&scoped=true&lang=pug"
import script from "./m-support-buttons.vue?vue&type=script&lang=js"
export * from "./m-support-buttons.vue?vue&type=script&lang=js"
import style0 from "./m-support-buttons.vue?vue&type=style&index=0&id=730e814e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e814e",
  null
  
)

export default component.exports